import { Tooltip } from '@bfe/moly';
import { useLocale } from '../../store/i18nMessage';
import qrCodeImg from '../Web3Footer/images/download-app.png';

export type DownloadAppProps = {};

export function DownloadApp(props: DownloadAppProps) {
  const { t } = useLocale();
  return (
    <Tooltip
      placement="bottomRight"
      overlayStyle={{
        '--bds-gray-ele-border': '#24252B',
      }}
      title={
        <div className="flex flex-col items-center">
          <img className=" size-40" src={qrCodeImg} alt="download-app" />
          <p className=" text-white text-base text-center my-4 px-2">{t('scan_to_download')}</p>
        </div>
      }
    >
      <div className="nav-link flex items-center cursor-pointer w-12">
        <div className="size-6 svg-full">{downloadIcon}</div>
      </div>
    </Tooltip>
  );
}

const downloadIcon = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M11.053 17.72c-0.125 0.124-0.224 0.271-0.292 0.434s-0.103 0.337-0.103 0.513 0.035 0.35 0.103 0.513c0.068 0.162 0.167 0.31 0.292 0.434l4 4c0.124 0.125 0.271 0.224 0.434 0.292s0.337 0.103 0.513 0.103 0.35-0.035 0.513-0.103c0.162-0.068 0.31-0.167 0.434-0.292l4-4c0.251-0.251 0.392-0.592 0.392-0.947s-0.141-0.696-0.392-0.947c-0.251-0.251-0.592-0.392-0.947-0.392s-0.696 0.141-0.947 0.392l-1.72 1.733v-15.453c0-0.354-0.141-0.693-0.391-0.943s-0.589-0.391-0.943-0.391c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943v15.453l-1.72-1.733c-0.124-0.125-0.271-0.224-0.434-0.292s-0.337-0.103-0.513-0.103c-0.176 0-0.35 0.035-0.513 0.103s-0.31 0.167-0.434 0.292zM24 12h-2.667c-0.354 0-0.693 0.14-0.943 0.391s-0.391 0.589-0.391 0.943c0 0.354 0.141 0.693 0.391 0.943s0.589 0.391 0.943 0.391h2.667c0.354 0 0.693 0.141 0.943 0.391s0.391 0.589 0.391 0.943v9.333c0 0.354-0.141 0.693-0.391 0.943s-0.589 0.391-0.943 0.391h-16c-0.354 0-0.693-0.141-0.943-0.391s-0.391-0.589-0.391-0.943v-9.333c0-0.354 0.14-0.693 0.391-0.943s0.589-0.391 0.943-0.391h2.667c0.354 0 0.693-0.141 0.943-0.391s0.391-0.589 0.391-0.943c0-0.354-0.14-0.693-0.391-0.943s-0.589-0.391-0.943-0.391h-2.667c-1.061 0-2.078 0.421-2.828 1.172s-1.172 1.768-1.172 2.828v9.333c0 1.061 0.421 2.078 1.172 2.828s1.768 1.172 2.828 1.172h16c1.061 0 2.078-0.421 2.828-1.172s1.172-1.768 1.172-2.828v-9.333c0-1.061-0.421-2.078-1.172-2.828s-1.768-1.172-2.828-1.172z"></path>
  </svg>
);
